<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title"
              >Linhas Regulares de Passageiros</v-card-title
            >
            <v-card-text class="app-card-content">
              <v-form
                ref="form"
                v-model="form.valid"
                lazy-validation
                @submit.prevent="onSubmit"
              >
                <v-row>
                  <v-col :md="6" :sm="6" :xs="12" cols="12">
                    <v-autocomplete
                      v-model="form.origem"
                      :loading="isLoadingOrigin"
                      :items="localidades"
                      :search-input.sync="searchLocalidadesOrigin"
                      :item-text="'nome'"
                      :item-value="'id'"
                      :rules="[rules.required]"
                      cache-items
                      hide-no-data
                      hide-details
                      label="Origem *"
                      placeholder="Selecione sua origem"
                      filled
                      rounded
                      dense
                    ></v-autocomplete>
                  </v-col>
                  <v-col :md="6" :sm="6" :xs="12" cols="12">
                    <v-autocomplete
                      v-model="form.destino"
                      :loading="isLoadingDestino"
                      :items="localidades"
                      :search-input.sync="searchLocalidadesDestino"
                      :item-text="'nome'"
                      :item-value="'id'"
                      :rules="[rules.required]"
                      cache-items
                      hide-no-data
                      hide-details
                      label="Destino *"
                      placeholder="Selecione seu destino"
                      filled
                      rounded
                      dense
                    ></v-autocomplete>
                  </v-col>
                  <v-col :md="9" :sm="9" :xs="12" cols="12">
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :loadRecaptchaScript="true"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                      class="recaptcha"
                    ></vue-recaptcha>
                    <v-input
                      v-model="form.recaptcha"
                      :rules="[rules.required]"
                    ></v-input>
                  </v-col>
                  <v-col :md="3" :sm="3" :xs="12" cols="12">
                    <v-btn depressed block large color="primary" type="submit"
                      >Continuar</v-btn
                    >
                  </v-col>
                </v-row>
              </v-form>
              <div class="loading" v-if="isLoading">
                <v-progress-circular
                  :size="25"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
          <div id="resulta-linhas-regulares"></div>
          <ResultaLinhasRegulares :linhas="linhas" v-if="linhas" />
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import { mask } from "vue-the-mask";
import LocalidadeService from "@/services/localidade.service";
import LinhaService from "@/services/linha.service";
import ResultaLinhasRegulares from "./Resultado";
import { throwError } from "rxjs";

export default {
  components: {
    VueRecaptcha,
    ResultaLinhasRegulares
  },
  directives: {
    mask
  },
  metaInfo: {
    title: "Linhas Regulares de Passageiros - Central de Serviços"
  },
  data() {
    return {
      siteKey: VUE_APP_RECAPTCHA_KEY,
      isLoading: false,
      localidades: [],
      isLoadingOrigin: false,
      searchLocalidadesOrigin: null,
      itemsLocalidadesOrigem: [],
      isLoadingDestino: false,
      searchLocalidadesDestino: null,
      itemsLocalidadesDestino: [],
      form: {
        origem: null,
        destinho: null,
        recaptcha: null
      },
      linhas: null,
      rules: {
        required: value => !!value || "Esse campo deve ser preenchido",
        pattern: value =>
          !!value.match(/^([0-9])*\/[0-9]{4}$/) ||
          "Esse campo está fora do padrão"
      }
    };
  },
  methods: {
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.isLoading = true;
        const { origem, destino, recaptcha } = this.form;
        LinhaService.findBy(origem, destino, recaptcha).subscribe(
          response => {
            this.isLoading = false;
            this.linhas = response;
            this.$vuetify.goTo("#resulta-linhas-regulares");
            this.expiredRecaptcha();
          },
          error => {
            this.linhas = null;
            this.isLoading = false;
            this.expiredRecaptcha();
            throwError(error);
          }
        );
      }
    },
    loadLocalidades() {
      LocalidadeService.getAll().subscribe(
        response => {
          this.localidades = response;
        },
        error => {
          //
        }
      );
    },
    querySelectionsLocalidadesOrigem(value) {
      this.isLoadingOrigin = true;
      this.itemsLocalidadesOrigem = this.localidades.filter(e => {
        return (
          (e.nome || "").toLowerCase().indexOf((value || "").toLowerCase()) > -1
        );
      });
      this.isLoadingOrigin = false;
    },
    querySelectionsLocalidadesDestino(value) {
      this.isLoadingDestino = true;
      this.itemsLocalidadesDestino = this.localidades.filter(e => {
        return (
          (e.nome || "").toLowerCase().indexOf((value || "").toLowerCase()) > -1
        );
      });
      this.isLoadingDestino = false;
    }
  },
  watch: {
    searchLocalidadesOrigin(val) {
      val &&
        val !== this.form.origem &&
        this.querySelectionsLocalidadesOrigem(val);
    },
    searchLocalidadesDestino(val) {
      val &&
        val !== this.form.destino &&
        this.querySelectionsLocalidadesDestino(val);
    }
  },
  mounted() {
    this.loadLocalidades();
  }
};
</script>

<style></style>
